import { useLocation } from "react-router-dom";

function Title() {
  const { pathname } = useLocation();

  return (
    <div className="home-title-pagee py-5">
      <p className="colloborate-title mb-0 rtl-all">
        <span>ثبت سفارش </span>
        <span>
          {pathname.includes("/new/cod")
            ? "پرداخت در محل - پسکرایه (COD)"
            : "پیشکرایه (آنلاین)"}
        </span>
      </p>
    </div>
  );
}

export default Title;
